import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./globals.css";

console.log("[main.tsx] Starting application...");
console.log("[main.tsx] Root element:", document.getElementById("root"));

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

console.log("[main.tsx] React app rendered");
